import { useEffect } from "react";

function upsert(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

// Dynamically manages per-page SEO tags (title, description, canonical, OG/Twitter, JSON-LD) for
// these public SPA routes so crawlers see unique, keyword-rich metadata per gladiator/battle.
export function usePageMeta({ title, description, canonical, jsonLd }) {
  const ld = jsonLd ? JSON.stringify(jsonLd) : "";
  useEffect(() => {
    if (title) {
      document.title = title;
      upsert("property", "og:title", title);
      upsert("name", "twitter:title", title);
    }
    if (description) {
      upsert("name", "description", description);
      upsert("property", "og:description", description);
      upsert("name", "twitter:description", description);
    }
    if (canonical) {
      upsert("property", "og:url", canonical);
      let link = document.head.querySelector('link[rel="canonical"]');
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
    let script;
    if (ld) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.text = ld;
      document.head.appendChild(script);
    }
    return () => {
      if (script) script.remove();
      const link = document.head.querySelector('link[rel="canonical"]');
      if (link && canonical) link.remove();
    };
  }, [title, description, canonical, ld]);
}
